export default "__VITE_ASSET__DZ7c0N_3__"